export default __webpack_public_path__ + "static/media/404.d7e4d16b.svg";